import { render, staticRenderFns } from "./PoliceverificationFilter.vue?vue&type=template&id=21b69d3e&scoped=true&"
import script from "./PoliceverificationFilter.vue?vue&type=script&lang=js&"
export * from "./PoliceverificationFilter.vue?vue&type=script&lang=js&"
import style0 from "./PoliceverificationFilter.vue?vue&type=style&index=0&id=21b69d3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b69d3e",
  null
  
)

export default component.exports